import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import styled from 'styled-components';
import { Section } from '@finect/tabular-core/Section';
import { H2 } from '@finect/tabular-core/Headings';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { Small } from '@finect/tabular-core/Small';
import { Button } from '@finect/tabular-core/Button';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Datalayer, DatalayerScene } from '@finect/front-gtm';
import { isBrowser } from '@finect/front-utils/isBrowser';
import { Head } from './Head';
var SectionInner = styled.div.withConfig({
  displayName: "NotFound__SectionInner",
  componentId: "sc-16drxex-0"
})(["min-height:380px;padding:90px 30px 30px;text-align:center;h2,p{display:block;}a{color:#fff;}"]);
export var NotFound = function NotFound(props) {
  var staticContext = props.staticContext,
    _props$message = props.message,
    message = _props$message === void 0 ? 'Lo sentimos pero parece que esta página no existe.' : _props$message,
    _props$redirectPath = props.redirectPath,
    redirectPath = _props$redirectPath === void 0 ? "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com') : _props$redirectPath,
    _props$actionText = props.actionText,
    actionText = _props$actionText === void 0 ? 'Volver a Finect' : _props$actionText;
  if (staticContext) {
    staticContext.statusCode = 404;
  }
  return React.createElement(Section, null, React.createElement(Head, {
    title: "Error 404"
  }), isBrowser() ? React.createElement(React.Fragment, null, React.createElement(DatalayerScene, {
    pageType: "error",
    pageId: "404"
  }), React.createElement(Datalayer, {
    id: "FiEvent",
    type: "fiEvent",
    params: {
      category: 'Error',
      label: '404',
      action: props.location ? props.location.pathname + props.location.search : undefined
    }
  })) : null, React.createElement(SectionInner, {
    center: true
  }, React.createElement(H2, null, "Ups!"), React.createElement(ParagraphSmall, {
    center: true
  }, message, React.createElement("br", null), React.createElement(Small, {
    light: true
  }, "(Error 404)")), React.createElement(Button, {
    as: AppLink,
    variant: "medium",
    width: "auto",
    href: redirectPath
  }, actionText)));
};